import { CatSkeleton } from '@blocks-react/components/Skeleton';
import { CatHeading } from '@blocks-react/components/Heading';
import styles from '../request-equipment-service-search-loader.module.scss';

import { RequestServiceLoaderDesktopProps } from '../types';
import { CustomStyledLabel } from '@cat-ecom/pcc-components';

export const RequestServiceLoaderDesktop = ({
  dateLabel,
  contactLabel
}: RequestServiceLoaderDesktopProps) => {
  return (
    <div data-testid="requestServiceLoaderDesktop">
      <div className="d-flex mb-4">
        <div className={styles['equipment-info__image-loader-desktop']}>
          <CatSkeleton />
        </div>
        <div
          className={`ms-3 ${styles['equipment-info__name-loader-desktop']}`}
        >
          <CatSkeleton />
        </div>
      </div>
      <CatSkeleton size="lg" />
      <div className="mt-4 d-flex justify-content-between align-items-baseline">
        <div className={styles['description__heading']}>
          <CatSkeleton size="sm" />
        </div>
        <div className={styles['description__count']}>
          <CatSkeleton size="sm" />
        </div>
      </div>
      <div className="mt-2 mb-4">
        <CatSkeleton size="lg" />
        <CatSkeleton size="sm" />
      </div>
      <hr className="mb-4" />
      <div className="d-flex align-items-center flex-column">
        <CatHeading variant="label">
          <CustomStyledLabel>{dateLabel}</CustomStyledLabel>
        </CatHeading>
        <div className={`mt-4 mb-3 ${styles['preferred-date-loader-width']}`}>
          <CatSkeleton />
        </div>
        <div className={styles['preferred-date__center-loader']}>
          <CatSkeleton size="lg" />
          <CatSkeleton size="lg" />
        </div>
        <div
          className={`mt-3 pb-2
            ${styles['preferred-date__center-message-loader']}`}
        >
          <CatSkeleton size="sm" />
        </div>
        <div className={`mb-4 ${styles['preferred-date__bottom-loader']}`}>
          <CatSkeleton size="sm" />
        </div>
      </div>
      <CatHeading variant="label" className="text-center">
        <CustomStyledLabel>{contactLabel}</CustomStyledLabel>
      </CatHeading>
      <div className="my-4">
        <CatSkeleton size="lg" />
      </div>
      <div className={styles['preferred-contact-method-loader-width']}>
        <CatSkeleton />
      </div>
      <div className="mt-3 pt-2">
        <CatSkeleton size="sm" />
        <CatSkeleton />
      </div>
    </div>
  );
};
